import {
    LOGOUT_USER,
    CLIENT_GET_EXTENSIONS,
    CLIENT_GET_EXTENSIONS_SUCCESS,
    CLIENT_GET_EXTENSIONS_FAILED,
} from '../constants/index';


const INITIAL_STATE = {
    error: null, loading: false, data: []
};

export default function register(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOGOUT_USER:
        case CLIENT_GET_EXTENSIONS:
            return { ...state, loading: true, error: null, data: [] };
        case CLIENT_GET_EXTENSIONS_SUCCESS:
            return { ...state, loading: false, error: null, data: action.payload };
        case CLIENT_GET_EXTENSIONS_FAILED:
            return { ...state, loading: false, error: { header: action.payload.header, message: action.payload.message }, data: [] };
        default:
            return state;
    }
}
